import { render, staticRenderFns } from "./UcExchangeRateDateRuleDisplay.yaml?vue&type=template&id=3b16b4cc&component"
import script from "./UcExchangeRateDateRuleDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./UcExchangeRateDateRuleDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports